import clsx from "clsx";
import React from "react";
import Tooltip from "react-tooltip-lite";
import style from "./hint-bubble.module.css";

interface HintBubbleProps {
    tooltipText: React.ReactNode;
    className?: string;
}

function HintBubble({ className, tooltipText }: HintBubbleProps): JSX.Element {
    const content = <div className={style.hintBubbleTooltipWrapper}>{tooltipText}</div>;
    return (
        <Tooltip
            className={clsx(style.hintBubbleWrapper, className)}
            content={content}
            direction="up-end"
            padding="0"
            tipContentHover={true}
            arrowContent={<div className={style.arrow} />}
        >
            <span className={style.hintBubble} />
        </Tooltip>
    );
}

export default HintBubble;
